import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Building2, Users } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card } from "@/components/ui/card";

export default function AccountantClients() {
  const { t } = useI18n();
  const navigate = useNavigate();

  const { data: clients = [] } = useQuery({
    queryKey: ["accountant-clients"],
    queryFn: async () => (await api.get("/accountant/clients")).data,
  });

  return (
    <div className="space-y-6" data-testid="accountant-clients-page">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-sm bg-secondary flex items-center justify-center">
          <Users className="h-5 w-5 text-[hsl(var(--success))]" />
        </div>
        <div>
          <h1 className="font-display text-4xl">{t("accountant_clients_title")}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t("accountant_clients_sub")}</p>
        </div>
      </div>

      {clients.length === 0 ? (
        <Card className="p-16 rounded-sm border-dashed border-border text-center">
          <Building2 className="h-10 w-10 mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">{t("accountant_no_clients")}</p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {clients.map((c, i) => (
            <motion.div key={c.client_id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
              <Card
                className="p-6 rounded-sm border-border h-full cursor-pointer hover:border-foreground transition-colors"
                onClick={() => navigate(`/accountant/clients/${c.client_id}`)}
                data-testid={`client-card-${c.client_id}`}
              >
                <p className="font-display text-lg">{c.name}</p>
                <p className="text-sm text-muted-foreground mt-1">{c.email}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
